import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import pickImage from "./image";
import { LEAVE_CNT } from "../config";

pdfMake.vfs = pdfFonts?.pdfMake?.vfs;
pdfMake.fonts = {
  THSarabunNew: {
    normal: "THSarabun.ttf",
    bold: "THSarabun Bold.ttf",
    italics: "THSarabun Italic.ttf",
    bolditalics: "THSarabun BoldItalic.ttf",
  },
  Roboto: {
    normal: "Roboto-Regular.ttf",
    bold: "Roboto-Medium.ttf",
    italics: "Roboto-Italic.ttf",
    bolditalics: "Roboto-MediumItalic.ttf",
  },
};

const FormLeave = (r, _x, _y, _z, lastLeave, cntLeave) => {
  console.log('%csrc\pdf\formLeave.js:23 r', 'color: #007acc;', r);
  let user_signature = _x?.image_signature || null;
  let user_name = _x?.fullname_th || _x?.fullname_en || null;
  let user_position = _x?.position_name || null;

  let one_signature = _y?.image_signature || null;
  let one_name = _y?.fullname_th || _y?.fullname_en || null;
  let one_position = _y?.position_name || null;

  let two_signature = _z?.image_signature || null;
  let two_name = _z?.fullname_th || _z?.fullname_en || null;
  let two_position = _z?.position_name || null;

  let cntLeave2 = {};

  if (r.type_leave_id === 2) {
    cntLeave.forEach((x) => {
      if (x.leave_name === "ป่วย") {
        cntLeave2.sick = x.total;
      } else if (x.leave_name === "คลอดบุตร") {
        cntLeave2.personal = x.total;
      } else if (x.leave_name === "กิจส่วนตัว") {
        cntLeave2.maternity = x.total;
      }
    });
  }

  let last_date_Start = new Date(
    Number(lastLeave ? lastLeave.time_start : null)
  );
  let Last_dateStart_day = last_date_Start.toLocaleDateString("th-TH", {
    day: "numeric",
  });
  let Last_dateStart_month = last_date_Start.toLocaleDateString("th-TH", {
    month: "long",
  });
  let Last_dateStart_year = last_date_Start.toLocaleDateString("th-TH", {
    year: "numeric",
  });
  let last_Start_year = Last_dateStart_year.substring(
    Last_dateStart_year.length - 4
  );

  let last_date_End = new Date(Number(lastLeave ? lastLeave.time_end : null));
  let Last_dateEnd_day = last_date_End.toLocaleDateString("th-TH", {
    day: "numeric",
  });
  let Last_dateEnd_month = last_date_End.toLocaleDateString("th-TH", {
    month: "long",
  });
  let Last_dateEnd_year = last_date_End.toLocaleDateString("th-TH", {
    year: "numeric",
  });
  let last_End_year = Last_dateEnd_year.substring(Last_dateEnd_year.length - 4);

  let date_Start = new Date(r.time_start);
  let TH_dateStart_day = date_Start.toLocaleDateString("th-TH", {
    day: "numeric",
  });
  let TH_dateStart_month = date_Start.toLocaleDateString("th-TH", {
    month: "long",
  });
  let TH_dateStart_year = date_Start.toLocaleDateString("th-TH", {
    year: "numeric",
  });
  let TH_dateStart_time = date_Start.toLocaleDateString("th-TH", {
    hour: "numeric",
    minute: "numeric",
  });
  let Start_year = TH_dateStart_year.substring(TH_dateStart_year.length - 4);
  let Start_time = TH_dateStart_time.substring(TH_dateStart_time.length - 5);

  let date_End = new Date(r.time_end);
  let TH_dateEnd_day = date_End.toLocaleDateString("th-TH", { day: "numeric" });
  let TH_dateEnd_month = date_End.toLocaleDateString("th-TH", {
    month: "long",
  });
  let TH_dateEnd_year = date_End.toLocaleDateString("th-TH", {
    year: "numeric",
  });
  let TH_dateEnd_time = date_End.toLocaleDateString("th-TH", {
    hour: "numeric",
    minute: "numeric",
  });
  let End_year = TH_dateEnd_year.substring(TH_dateEnd_year.length - 4);
  let End_time = TH_dateEnd_time.substring(TH_dateEnd_time.length - 5);

  let Create_a = new Date(r.create_at);
  let TH_create_day = Create_a.toLocaleDateString("th-TH", { day: "numeric" });
  let TH_create_month = Create_a.toLocaleDateString("th-TH", { month: "long" });
  let TH_careat_year = Create_a.toLocaleDateString("th-TH", {
    year: "numeric",
  });
  let create_year = TH_careat_year.substring(TH_careat_year.length - 4);

  let sucess_time = new Date(r.sucess_time || r.one_success_time || r.update_at);
  let TH_sucess = sucess_time.toLocaleDateString("th-TH", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
  let TH_dateSucess_day = sucess_time.toLocaleDateString("th-TH", {
    day: "numeric",
  });
  let TH_dateSucess_month = sucess_time.toLocaleDateString("th-TH", {
    month: "long",
  });
  let TH_dateSucess_year = sucess_time.toLocaleDateString("th-TH", {
    year: "numeric",
  });
  let Sucess_year = TH_dateSucess_year.substring(TH_dateSucess_year.length - 4);

  if (r.type_leave_id === 2) {
    let dd = {
      info: {
        title: "แบบใบลาป่วย ลาคลอดบุตร ลากิจส่วนตัว",
      },
      content: [
        {
          text: "แบบใบลาป่วย ลาคลอดบุตร ลากิจส่วนตัว",
          style: "header",
          alignment: "center",
        },
        {
          columns: [
            {
              text: "(เขียนที่)",
              alignment: "left",
              width: 450,
              style: "bigger",
              margin: [330, 0, 0, 0],
            },
            {
              text: "........คณะโลจิสติกส์และดิจิทัลซัพพลายเชน........",
              alignment: "left",
              margin: [-100, 3, 0, 0],
            },
          ],
        },
        {
          text: "วันที่..............เดือน..........................พ.ศ..........",
          alignment: "right",
        },
        {
          columns: [
            {
              text: `${r.create_at ? TH_create_day : ""}`,
              width: 450,
              margin: [400, -18, 0, 0],
              alignment: "left",
            },
            {
              text: `${r.create_at ? TH_create_month : ""}`,
              width: 300,
              margin: [-25, -18, 0, 0],
              alignment: "left",
            },
            {
              text: `${r.create_at ? create_year : ""}`,
              width: 300,
              margin: [-290, -18, 0, 0],
              alignment: "left",
            },
          ],
        },
        {
          columns: [
            {
              text: "เรื่อง",
              alignment: "left",
              style: "bigger",
              width: "auto",
              margin: [0, 3, 0, 0],
            },
            {
              text: `................................................................................`,
              alignment: "left",
              width: "auto",
              margin: [-15, 6.5, 0, 0],
            },
          ],
        },
        {
          text: `${r.leave_name}`,
          alignment: "left",
          width: "auto",
          margin: [75, -15, 0, 0],
        },
        {
          columns: [
            {
              text: "เรียน",
              alignment: "left",
              style: "bigger",
              margin: [0, 3, 0, 0],
              width: "auto",
            },
            {
              text: ".........คณะโลจิสติกส์และดิจิทัลซัพพลายเชน.........",
              alignment: "left",
              margin: [-15, 6.5, 0, 10],
              width: "auto",
            },
          ],
        },
        {
          margin: [50, 0, 0, 0],

          table: {
            widths: [25, 120, 30, 105, 20, 118],
            headerRows: 1,
            body: [
              [
                { text: "ข้าพเจ้า", border: [false, false, false, false] },
                {
                  text: `${r.name}`,
                  margin: [0, 0, 0, -3],
                  border: [false, false, false, true],
                  alignment: "center",
                },
                { text: "ตำแหน่ง", border: [false, false, false, false] },
                {
                  text: user_position || "-",

                  border: [false, false, false, true],
                  alignment: "center",
                },
                { text: "สังกัด", border: [false, false, false, false] },
                {
                  text: `คณะโลจิสติกส์และดิจิทัลซัพพลายเชน`,

                  border: [false, false, false, true],
                  alignment: "center",
                },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },
        {
          columns: [
            {
              image: r.leave_name === "ป่วย" ? "checKed" : "unchecKed",
              width: 10,
              margin: [43, 3, 0, 0],
            },
            {
              text: "ป่วย",
              width: 100,
              margin: [43, 0, 0, 0],
              style: "bigger",
            },
          ],
        },
        {
          columns: [
            { text: "ขอลา", width: "auto", style: "bigger" },
            {
              image: r.leave_name === "กิจส่วนตัว" ? "checKed" : "unchecKed",
              width: 10,
              margin: [0, 3, 0, 0],
            },
            { text: "กิจส่วนตัว", width: "auto", style: "bigger" },
            {
              text: `เนื่องจาก...............${
                r.personal_affairs_detail ? r.personal_affairs_detail : ""
              }......................`,
              width: "auto",
              margin: [0, 2, 0, 0],
            },
          ],
        },
        {
          columns: [
            {
              image: r.leave_name === "คลอดบุตร" ? "checKed" : "unchecKed",
              width: 10,
              margin: [43, 3, 0, 0],
            },
            {
              text: "คลอดบุตร",
              width: 100,
              margin: [43, 0, 0, 0],
              style: "bigger",
            },
          ],
        },

        // {
        //   margin: [0, 10, 0, 0],

        //   table: {
        //     widths: [
        //       35, 10, 20, 55, 14, 30, 25, 20, 20, 55, 14, 20, 30, 35, 20,
        //     ],
        //     headerRows: 1,
        //     body: [
        //       [
        //         {
        //           text: "ตั้งเเต่วันที่",
        //           border: [false, false, false, false],
        //         },
        //         {
        //           text: `${TH_dateStart_day}`,
        //           border: [false, false, false, true],
        //           alignment: "center",
        //         },
        //         { text: "เดือน", border: [false, false, false, false] },
        //         {
        //           text: `${TH_dateStart_month}`,
        //           border: [false, false, false, true],
        //           alignment: "center",
        //         },
        //         { text: "พ.ศ.", border: [false, false, false, false] },
        //         {
        //           text: `${Start_year}`,
        //           border: [false, false, false, true],
        //           alignment: "center",
        //         },
        //         { text: "ถึงวันที่", border: [false, false, false, false] },
        //         {
        //           text: `${TH_dateEnd_day}`,
        //           border: [false, false, false, true],
        //           alignment: "center",
        //         },
        //         { text: "เดือน", border: [false, false, false, false] },
        //         {
        //           text: `${TH_dateEnd_month}`,
        //           border: [false, false, false, true],
        //           alignment: "center",
        //         },
        //         { text: "พ.ศ.", border: [false, false, false, false] },
        //         {
        //           text: `${End_year}`,
        //           border: [false, false, false, true],
        //           alignment: "center",
        //         },
        //         { text: "มีกำหนด", border: [false, false, false, false] },
        //         {
        //           text: `${r.scheduled}`,
        //           border: [false, false, false, true],
        //           alignment: "center",
        //         },
        //         { text: "วัน", border: [false, false, false, false] },
        //       ],
        //       [
        //         { text: "", border: [false, false, false, false] },
        //         { text: "", border: [false, false, false, false] },
        //         { text: "", border: [false, false, false, false] },
        //         { text: "", border: [false, false, false, false] },
        //         { text: "", border: [false, false, false, false] },
        //         { text: "", border: [false, false, false, false] },
        //         { text: "", border: [false, false, false, false] },
        //         { text: "", border: [false, false, false, false] },
        //         { text: "", border: [false, false, false, false] },
        //         { text: "", border: [false, false, false, false] },
        //         { text: "", border: [false, false, false, false] },
        //         { text: "", border: [false, false, false, false] },
        //         { text: "", border: [false, false, false, false] },
        //         { text: "", border: [false, false, false, false] },
        //         { text: "", border: [false, false, false, false] },
        //       ],
        //     ],
        //   },
        //   layout: {
        //     hLineStyle: function (i, node) {
        //       if (i === 0 || i === node.table.body.length) {
        //         return null;
        //       }
        //       return { dash: { length: 1, space: 1 } };
        //     },
        //     vLineStyle: function (i, node) {
        //       if (i === 0 || i === node.table.widths.length) {
        //         return null;
        //       }
        //       return { dash: { length: 10 } };
        //     },
        //   },
        // },
        {
          margin: [0, 10, 0, 0],

          table: {
            widths: [
              35, 10, 20, 30, 15, 20, 20, 30, 25, 10, 20, 30, 15, 20, 10, 20,
            ],
            headerRows: 1,
            body: [
              [
                {
                  text: "ตั้งเเต่วันที่",
                  border: [false, false, false, false],
                },
                {
                  text: `${TH_dateStart_day}`,
                  margin: [0, 0, 0, -10],
                  border: [false, false, false, true],
                  alignment: "center",
                },
                { text: "เดือน", border: [false, false, false, false] },
                {
                  text: `${TH_dateStart_month}`,
                  border: [false, false, false, true],
                  alignment: "center",
                },
                { text: "พ.ศ.", border: [false, false, false, false] },
                {
                  text: `${Start_year}`,
                  border: [false, false, false, true],
                  alignment: "center",
                },
                { text: "เวลา", border: [false, false, false, false] },
                {
                  text: `${Start_time}`,
                  border: [false, false, false, true],
                  alignment: "center",
                },
                { text: "ถึงวันที่", border: [false, false, false, false] },
                {
                  text: `${TH_dateEnd_day}`,
                  border: [false, false, false, true],
                  alignment: "center",
                },
                { text: "เดือน", border: [false, false, false, false] },
                {
                  text: `${TH_dateEnd_month}`,
                  border: [false, false, false, true],
                  alignment: "center",
                },
                { text: "พ.ศ.", border: [false, false, false, false] },
                {
                  text: `${End_year}`,
                  border: [false, false, false, true],
                  alignment: "center",
                },
                { text: "ถึง", border: [false, false, false, false] },
                {
                  text: `${End_time}`,
                  border: [false, false, false, true],
                  alignment: "center",
                },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },
        {
          margin: [0, 0, 0, 0],

          table: {
            widths: [50, 20, 20, 20, 35, 20, 40, 67, 20, 20, 50, 15, 30],
            headerRows: 1,
            body: [
              [
                { text: "ข้าพเจ้าได้ลา", border: [false, false, false, false] },
                {
                  image:
                    lastLeave?.leave_name === "ป่วย" ? "checKed" : "unchecKed",
                  border: [false, false, false, false],
                  width: 10,
                },
                { text: "ป่วย", border: [false, false, false, false] },
                {
                  image:
                    lastLeave?.leave_name === "คลอดบุตร"
                      ? "checKed"
                      : "unchecKed",
                  border: [false, false, false, false],
                  width: 10,
                },
                { text: "คลอดบุตร", border: [false, false, false, false] },
                {
                  image:
                    lastLeave?.leave_name === "กิจส่วนตัว"
                      ? "checKed"
                      : "unchecKed",
                  border: [false, false, false, false],
                  width: 10,
                },
                { text: "กิจส่วนตัว", border: [false, false, false, false] },
                {
                  text: "ครั้งสุดท้ายตั้งเเต่วันที่",
                  border: [false, false, false, false],
                },
                {
                  text: `${lastLeave ? Last_dateStart_day : "-"}`,
                  border: [false, false, false, true],
                  alignment: "center",
                },
                { text: "เดือน", border: [false, false, false, false] },
                {
                  text: `${lastLeave ? Last_dateStart_month : "-"}`,
                  border: [false, false, false, true],
                  alignment: "center",
                },
                { text: "พ.ศ.", border: [false, false, false, false] },
                {
                  text: `${lastLeave ? last_Start_year : "-"}`,
                  border: [false, false, false, true],
                  alignment: "center",
                },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },
        {
          margin: [0, 0, 0, 0],

          table: {
            widths: [30, 20, 30, 50, 20, 30, 35, 20, 120, 78],
            headerRows: 1,
            body: [
              [
                { text: "ถึงวันที่", border: [false, false, false, false] },
                {
                  text: `${lastLeave ? Last_dateEnd_day : "-"}`,
                  border: [false, false, false, true],
                  alignment: "center",
                },
                { text: "เดือน", border: [false, false, false, false] },
                {
                  text: `${lastLeave ? Last_dateEnd_month : "-"}`,
                  border: [false, false, false, true],
                  alignment: "center",
                },
                { text: "พ.ศ.", border: [false, false, false, false] },
                {
                  text: `${lastLeave ? last_End_year : "-"}`,
                  border: [false, false, false, true],
                  alignment: "center",
                },
                { text: "มีกำหนด", border: [false, false, false, false] },
                {
                  text: `${lastLeave ? lastLeave.scheduled : "-"}`,
                  border: [false, false, false, true],
                  alignment: "center",
                },
                {
                  text: "วัน ในระหว่างลาจะติดต่อข้าพเจ้าได้ที่",
                  border: [false, false, false, false],
                },
                {
                  text: "",
                  border: [false, false, false, true],
                  alignment: "center",
                },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },

        {
          margin: [8, 0, 0, 0],

          table: {
            widths: [395, 45, 50],
            headerRows: 1,
            body: [
              [
                {
                  text: `${r.address ? r.address.replace("\n") : "-"}`,
                  border: [false, false, false, true],
                  alignment: "left",
                },
                { text: "หรือโทรศัพท์", border: [false, false, false, false] },
                {
                  text: `${r.phone}`,
                  border: [false, false, false, true],
                  alignment: "center",
                },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },

        {
          margin: [350, 20, 0, 0],
          alignment: "right",
          table: {
            widths: [100],
            headerRows: 1,
            body: [
              [
                {
                  text: "ขอแสดงความนับถือ",
                  margin: [0, 0, 0, 0],
                  style: "bigger",
                  border: [false, false, false, false],
                },
              ],
              [{ text: "", border: [false, false, false, false] }],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },
        {
          margin: [328, 0, 0, 0],

          table: {
            widths: [25, 100],
            headerRows: 1,
            body: [
              [
                {
                  text: "(ลงชื่อ)",
                  margin: [0, 25, 0, 0],
                  border: [false, false, false, false],
                },
                user_signature
                  ? {
                      image: `${user_signature}`,
                      width: 100,
                      height: 30,
                      margin: [0, 0, 0, 0],
                      border: [false, false, false, true],
                      alignment: "center",
                    }
                  : { text: "", border: [false, false, false, false] },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },

        {
          margin: [365, 0, 0, 0],

          table: {
            widths: [100],
            headerRows: 1,
            body: [
              [
                {
                  text: `(.................................................)`,
                  margin: [0, 0, 0, 0],
                  border: [false, false, false, false],
                  alignment: "center",
                },
              ],
              [{ text: "", border: [false, false, false, false] }],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },
        {
          margin: [365, -30, 0, 0],

          table: {
            widths: [100],
            headerRows: 1,
            body: [
              [
                {
                  text: `${!user_name ? "" : user_name}`,
                  margin: [0, 0, 0, 0],
                  border: [false, false, false, false],
                  alignment: "center",
                },
              ],
              [{ text: "", border: [false, false, false, false] }],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },

        {
          margin: [320, 0, 0, 0],

          table: {
            widths: [35, 100],
            headerRows: 1,
            body: [
              [
                {
                  text: "ตำแหน่ง",
                  margin: [0, 0, 0, 0],
                  style: "bigger",
                  border: [false, false, false, false],
                },
                {
                  text: `${!user_position ? "" : user_position}`,
                  margin: [0, 0, 0, 0],
                  border: [false, false, false, true],
                  alignment: "center",
                },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },
        {
          margin: [320, 0, 0, 0],

          table: {
            widths: [320],
            headerRows: 1,
            body: [
              [
                {
                  text: `ความเห็นผู้บังคับบัญชา\nเรียน  คณบดีคณะโลจิสติกส์และดิจิทัลซัพพลายเชน`,
                  margin: [0, 0, 0, 0],
                  style: "bigger",
                  border: [false, false, false, false],
                },
              ],
              [{ text: "", border: [false, false, false, false] }],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },
        {
          margin: [345, -5, 0, 0],

          table: {
            widths: [110],
            headerRows: 1,
            body: [
              [
                {
                  text: `เพื่อโปรดพิจารณาอนุญาต`,
                  margin: [0, 0, 0, 0],
                  style: "bigger",
                  border: [false, false, false, false],
                },
              ],
              [{ text: "", border: [false, false, false, false] }],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },
        {
          margin: [328, 0, 0, 0],

          table: {
            widths: [25, 100],
            headerRows: 1,
            body: [
              [
                {
                  text: "(ลงชื่อ)",
                  margin: [0, 25, 0, 0],
                  border: [false, false, false, false],
                },
                one_signature
                  ? {
                      image: `${one_signature}`,
                      width: 100,
                      height: 30,
                      margin: [0, 0, 0, 0],
                      border: [false, false, false, true],
                      alignment: "center",
                    }
                  : { text: "", border: [false, false, false, false] },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },

        {
          margin: [335, 0, 0, 0],

          table: {
            widths: [150],
            headerRows: 1,
            body: [
              [
                {
                  text: `(........${!one_name ? "" : one_name}.......)`,
                  margin: [0, 0, 0, 0],
                  border: [false, false, false, false],
                  alignment: "center",
                },
              ],
              [{ text: "", border: [false, false, false, false] }],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },

        {
          margin: [328, 0, 0, 0],

          table: {
            widths: [27, 100],
            headerRows: 1,
            body: [
              [
                {
                  text: "ตำแหน่ง",
                  margin: [0, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: `${!one_position ? "" : one_position}`,
                  margin: [0, 0, 0, 0],
                  border: [false, false, false, true],
                  alignment: "center",
                },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },
        {
          margin: [320, 0, 0, 0],
          table: {
            widths: [15, 15, 20, 50, 20, 25],
            headerRows: 1,
            body: [
              [
                {
                  text: `วันที่`,
                  border: [false, false, false, false],
                },
                {
                  text: `${r.sucess_time ? TH_dateSucess_day : ""}`,
                  border: [false, false, false, true],
                },
                {
                  text: `เดือน`,
                  border: [false, false, false, false],
                },
                {
                  text: `${r.sucess_time ? TH_dateSucess_month : ""}`,
                  border: [false, false, false, true],
                },
                {
                  text: `พ.ศ.`,
                  border: [false, false, false, false],
                },
                {
                  text: `${r.sucess_time ? Sucess_year : ""}`,
                  border: [false, false, false, true],
                },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },

        {
          margin: [328, 10, 0, 0],

          table: {
            widths: [30, 20, 40, 20, 45],
            headerRows: 1,
            body: [
              [
                {
                  text: "คำสั่ง",
                  border: [false, false, false, false],
                  margin: [0, -3, 0, 0],
                  style: "bigger",
                },
                {
                  image: `${r.status === "อนุมัติ" ? "checKed" : "unchecKed"}`,
                  border: [false, false, false, false],
                  width: 10,
                },
                {
                  text: "อนุญาต",
                  margin: [0, -3, 0, 0],
                  border: [false, false, false, false],
                  style: "bigger",
                },
                {
                  image: `${
                    r.status === "ไม่อนุมัติ" ? "checKed" : "unchecKed"
                  }`,
                  border: [false, false, false, false],
                  width: 10,
                },
                {
                  text: "ไม่อนุญาต",
                  margin: [0, -3, 0, 0],
                  border: [false, false, false, false],
                  style: "bigger",
                },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },
        {
          margin: [328, 0, 0, 0],

          table: {
            widths: [25, 100],
            headerRows: 1,
            body: [
              [
                {
                  text: "(ลงชื่อ)",
                  margin: [0, 25, 0, 0],
                  border: [false, false, false, false],
                },
                two_signature
                  ? {
                      image: `${two_signature}`,
                      width: 100,
                      height: 30,
                      margin: [0, 0, 0, 0],
                      border: [false, false, false, true],
                      alignment: "center",
                    }
                  : { text: "", border: [false, false, false, false] },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },

        {
          margin: [335, 0, 0, 0],

          table: {
            widths: [150],
            headerRows: 1,
            body: [
              [
                {
                  text: `( ${!two_name ? "" : two_name} )`,
                  margin: [0, 0, 0, 0],
                  border: [false, false, false, false],
                  alignment: "center",
                },
              ],
              [{ text: "", border: [false, false, false, false] }],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },

        {
          margin: [328, 0, 0, 0],

          table: {
            widths: [30, 100],
            headerRows: 1,
            body: [
              [
                {
                  text: "ตำแหน่ง",
                  margin: [0, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: `${!two_position ? "" : two_position}`,
                  margin: [0, 0, 0, 0],
                  border: [false, false, false, true],
                  alignment: "center",
                },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },
        {
          margin: [320, 0, 0, 0],
          table: {
            widths: [15, 15, 20, 50, 20, 25],
            headerRows: 1,
            body: [
              [
                {
                  text: `วันที่`,
                  border: [false, false, false, false],
                },
                {
                  text: `${r.sucess_time ? TH_dateSucess_day : ""}`,
                  border: [false, false, false, true],
                },
                {
                  text: `เดือน`,
                  border: [false, false, false, false],
                },
                {
                  text: `${r.sucess_time ? TH_dateSucess_month : ""}`,
                  border: [false, false, false, true],
                },
                {
                  text: `พ.ศ.`,
                  border: [false, false, false, false],
                },
                {
                  text: `${r.sucess_time ? Sucess_year : ""}`,
                  border: [false, false, false, true],
                },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },

        {
          text: "สถิติการลาในปีงบประมาณนี้",
          margin: [0, -250, 0, 0],
          alignment: "left",
          style: "bigger",
        },
        {
          columns: [
            {
              style: "tableExample",
              alignment: "center",
              table: {
                body: [
                  [
                    "ประเภทการลา",
                    "ลามาเเล้ว\n(วันทำการ)",
                    "ลาครั้งนี้\n(วันทำการ)",
                    "รวม\n(วันทำการ)",
                  ],
                  [
                    "ป่วย",
                    cntLeave2.sick || "-",
                    r.scheduled || "-",
                    Number(cntLeave2.sick) + Number(r.scheduled) || "-",
                  ],
                  [
                    "กิจส่วนตัว",
                    cntLeave2.personal || "-",
                    r.scheduled || "-",
                    Number(cntLeave2.personal) + Number(r.scheduled) || "-",
                  ],
                  [
                    "คลอดบุตร",
                    cntLeave2.maternity || "-",
                    r.scheduled || "-",
                    Number(cntLeave2.maternity) + Number(r.scheduled) || "-",
                  ],
                ],
              },
            },
          ],
        },

        {
          margin: [0, 0, 0, 0],

          table: {
            widths: [25, 100, 40],
            headerRows: 1,
            body: [
              [
                {
                  text: "(ลงชื่อ)",
                  margin: [0, 25, 0, 0],
                  border: [false, false, false, false],
                },
                one_signature
                  ? {
                      image: `${one_signature}`,
                      width: 100,
                      height: 30,
                      margin: [0, 0, 0, 0],
                      border: [false, false, false, true],
                      alignment: "center",
                    }
                  : { text: "", border: [false, false, false, false] },

                {
                  text: "ผู้ตรวจสอบ",
                  margin: [0, 25, 0, 0],
                  border: [false, false, false, false],
                },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },

        {
          margin: [10, 0, 0, 0],

          table: {
            widths: [150],
            headerRows: 1,
            body: [
              [
                {
                  text: `(........${!one_name ? "" : one_name}.......)`,
                  margin: [0, 0, 0, 0],
                  border: [false, false, false, false],
                  alignment: "center",
                },
              ],
              [{ text: "", border: [false, false, false, false] }],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },

        {
          margin: [0, 0, 0, 0],
          table: {
            widths: [25, 10, 15, 10, 40, 25],
            headerRows: 1,
            body: [
              [
                {
                  text: `ผู้ตรวจ`,
                  border: [false, false, false, false],
                },
                {
                  text: ``,
                  border: [false, false, false, true],
                },
                {
                  text: `วันที่`,
                  border: [false, false, false, false],
                },
                {
                  text: `${r.sucess_time ? TH_dateSucess_day : ""}`,
                  border: [false, false, false, true],
                },
                {
                  text: `${r.sucess_time ? TH_dateSucess_month : ""}`,
                  border: [false, false, false, true],
                },
                {
                  text: `${r.sucess_time ? Sucess_year : ""}`,
                  border: [false, false, false, true],
                },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },
      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
        },
        tableExample: {
          margin: [0, 5, 0, 15],
        },
        bigger: {
          fontSize: 15,
          bold: true,
        },
      },
      defaultStyle: {
        columnGap: 20,
        font: "THSarabunNew",
      },
      images: {
        checKed:
          "data:image/png;base64,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",
        unchecKed:
          "data:image/png;base64,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",
      },
    };
    pdfMake.createPdf(dd).open();
  } else {
    let date_Start = new Date(r.time_start);
    let TH_dateStart_date = date_Start.toLocaleDateString("th-TH", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
    let date_End = new Date(r.time_end);
    let TH_dateEnd_date = date_End.toLocaleDateString("th-TH", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
    let dd = {
      info: {
        title: "แบบใบลาพักผ่อน",
      },
      content: [
        { text: "แบบใบลาพักผ่อน", style: "header", alignment: "center" },

        {
          text: "(เขียนที่)........คณะโลจิสติกส์และดิจิทัลซัพพลายเชน........",
          alignment: "right",
        },
        {
          text: "วันที่..............เดือน..........................พ.ศ..........",
          alignment: "right",
        },
        {
          columns: [
            {
              text: `${r.create_at ? TH_create_day : ""}`,
              width: 450,
              margin: [400, -18, 0, 0],
              alignment: "left",
            },
            {
              text: `${r.create_at ? TH_create_month : ""}`,
              width: 300,
              margin: [-25, -18, 0, 0],
              alignment: "left",
            },
            {
              text: `${r.create_at ? create_year : ""}`,
              width: 300,
              margin: [-290, -18, 0, 0],
              alignment: "left",
            },
          ],
        },
        {
          columns: [
            {
              text: "เรื่อง",
              alignment: "left",
              style: "bigger",
              width: "auto",
              margin: [0, 3, 0, 0],
            },
            {
              text: `.................................ขอลาพักผ่อน...................................`,
              alignment: "left",
              width: "auto",
              margin: [-15, 6.5, 0, 0],
            },
          ],
        },

        {
          columns: [
            {
              text: "เรียน",
              alignment: "left",
              style: "bigger",
              margin: [0, 3, 0, 0],
              width: "auto",
            },
            {
              text: ".........คณบดีคณะโลจิสติกส์และดิจิทัลซัพพลายเชน.........",
              alignment: "left",
              margin: [-15, 6.5, 0, 10],
              width: "auto",
            },
          ],
        },

        {
          margin: [80, 0, 0, 0],
          table: {
            widths: [25, 170, 30, 170],
            headerRows: 1,
            body: [
              [
                {
                  text: `ข้าพเจ้า`,
                  border: [false, false, false, false],
                },
                {
                  text: `${r.name}`,
                  border: [false, false, false, true],
                  alignment: "center",
                },
                {
                  text: `ตำแหน่ง`,
                  border: [false, false, false, false],
                },
                {
                  text: `${user_position || ""}`,
                  alignment: "center",
                  border: [false, false, false, true],
                },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },
        {
          margin: [0, 0, 0, 0],
          table: {
            widths: [25, 100, 135, 15, 130, 15, 40],
            headerRows: 1,
            body: [
              [
                {
                  text: `สังกัด`,
                  border: [false, false, false, false],
                },
                {
                  text: `${_x.dept_name || ""}`,
                  border: [false, false, false, true],
                  alignment: "center",
                },
                {
                  text: `มหาวิทยาลัยนเรศวร มีวันลาพักผ่อนสะสม`,
                  border: [false, false, false, false],
                },
                {
                  text: LEAVE_CNT.person || "",
                  alignment: "center",
                  border: [false, false, false, true],
                },
                {
                  text: `วันทำการ มีสิทธิลาพักผ่อนประจำปีนี้อีก`,
                  border: [false, false, false, false],
                },
                {
                  text: LEAVE_CNT.year || "",
                  alignment: "center",
                  border: [false, false, false, true],
                },
                {
                  text: `วันทำการ`,
                  border: [false, false, false, false],
                },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },
        {
          margin: [0, 0, 0, 0],
          table: {
            widths: [30, 15, 100, 15, 100, 80, 25, 75],
            headerRows: 1,
            body: [
              [
                {
                  text: `รวมเป็น`,
                  border: [false, false, false, false],
                },
                {
                  text: LEAVE_CNT.person + LEAVE_CNT.year || "",
                  border: [false, false, false, true],
                  alignment: "center",
                },
                {
                  text: `วันทำการ มีวันลาพักผ่อนสะสม`,
                  border: [false, false, false, false],
                },
                {
                  text: cntLeave?.[0]?.total || "",
                  alignment: "center",
                  border: [false, false, false, true],
                },
                {
                  text: `วันทำการ ขอลาพักผ่อน ตั้งวันที่`,
                  border: [false, false, false, false],
                },
                {
                  text: `${TH_dateStart_date ? TH_dateStart_date : ""}`,
                  alignment: "center",
                  border: [false, false, false, true],
                },
                {
                  text: `ถึงวันที่`,
                  border: [false, false, false, false],
                },
                {
                  text: `${TH_dateEnd_date ? TH_dateEnd_date : ""}`,
                  alignment: "center",
                  border: [false, false, false, true],
                },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },

        {
          margin: [0, 0, 0, 0],
          table: {
            widths: [30, 15, 10, 110, 300],
            headerRows: 1,
            body: [
              [
                {
                  text: `มีกำหนด`,
                  border: [false, false, false, false],
                },
                {
                  text: `${r.scheduled ? r.scheduled : ""}`,
                  alignment: "center",
                  border: [false, false, false, true],
                },
                {
                  text: `วัน`,
                  border: [false, false, false, false],
                },
                {
                  text: `ในระหว่างลาจะติดต่อข้าพเจ้าได้ที่`,
                  border: [false, false, false, false],
                },
                {
                  text: `${r.address ? r.address.replace("\n") : "-"}`,
                  alignment: "center",
                  border: [false, false, false, true],
                },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },

        {
          margin: [0, 0, 0, 0],
          table: {
            widths: [50, 100],
            headerRows: 1,
            body: [
              [
                {
                  text: `หรือโทรศัพท์`,
                  border: [false, false, false, false],
                },
                {
                  text: `${r.phone ? r.phone : ""}`,
                  alignment: "center",
                  border: [false, false, false, true],
                },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },

        {
          margin: [350, 20, 0, 0],
          alignment: "right",
          table: {
            widths: [100],
            headerRows: 1,
            body: [
              [
                {
                  text: "ขอแสดงความนับถือ",
                  margin: [0, 0, 0, 0],
                  style: "bigger",
                  border: [false, false, false, false],
                },
              ],
              [{ text: "", border: [false, false, false, false] }],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },
        {
          margin: [328, 0, 0, 0],

          table: {
            widths: [25, 100],
            headerRows: 1,
            body: [
              [
                {
                  text: "(ลงชื่อ)",
                  margin: [0, 25, 0, 0],
                  border: [false, false, false, false],
                },
                user_signature
                  ? {
                      image: `${user_signature}`,
                      width: 100,
                      height: 30,
                      margin: [0, 0, 0, 0],
                      border: [false, false, false, true],
                      alignment: "center",
                    }
                  : { text: "", border: [false, false, false, false] },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },

        {
          margin: [365, 0, 0, 0],

          table: {
            widths: [100],
            headerRows: 1,
            body: [
              [
                {
                  text: `(.................................................)`,
                  margin: [0, 0, 0, 0],
                  border: [false, false, false, false],
                  alignment: "center",
                },
              ],
              [{ text: "", border: [false, false, false, false] }],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },
        {
          margin: [365, -30, 0, 0],

          table: {
            widths: [100],
            headerRows: 1,
            body: [
              [
                {
                  text: `${!user_name ? "" : user_name}`,
                  margin: [0, 0, 0, 0],
                  border: [false, false, false, false],
                  alignment: "center",
                },
              ],
              [{ text: "", border: [false, false, false, false] }],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },

        {
          margin: [320, 0, 0, 0],

          table: {
            widths: [35, 100],
            headerRows: 1,
            body: [
              [
                {
                  text: "ตำแหน่ง",
                  margin: [0, 0, 0, 0],
                  style: "bigger",
                  border: [false, false, false, false],
                },
                {
                  text: `${!user_position ? "" : user_position}`,
                  margin: [0, 0, 0, 0],
                  border: [false, false, false, true],
                  alignment: "center",
                },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },
        {
          margin: [320, 0, 0, 0],

          table: {
            widths: [320],
            headerRows: 1,
            body: [
              [
                {
                  text: `ความเห็นผู้บังคับบัญชา\nเรียน  คณบดีคณะโลจิสติกส์และดิจิทัลซัพพลายเชน`,
                  margin: [0, 0, 0, 0],
                  style: "bigger",
                  border: [false, false, false, false],
                },
              ],
              [{ text: "", border: [false, false, false, false] }],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },
        {
          margin: [345, -5, 0, 0],

          table: {
            widths: [110],
            headerRows: 1,
            body: [
              [
                {
                  text: `เพื่อโปรดพิจารณาอนุญาต`,
                  margin: [0, 0, 0, 0],
                  style: "bigger",
                  border: [false, false, false, false],
                },
              ],
              [{ text: "", border: [false, false, false, false] }],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },
        {
          margin: [328, 0, 0, 0],

          table: {
            widths: [25, 100],
            headerRows: 1,
            body: [
              [
                {
                  text: "(ลงชื่อ)",
                  margin: [0, 25, 0, 0],
                  border: [false, false, false, false],
                },
                one_signature
                  ? {
                      image: `${one_signature}`,
                      width: 100,
                      height: 30,
                      margin: [0, 0, 0, 0],
                      border: [false, false, false, true],
                      alignment: "center",
                    }
                  : { text: "", border: [false, false, false, false] },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },

        {
          margin: [335, 0, 0, 0],

          table: {
            widths: [150],
            headerRows: 1,
            body: [
              [
                {
                  text: `(........${!one_name ? "" : one_name}.......)`,
                  margin: [0, 0, 0, 0],
                  border: [false, false, false, false],
                  alignment: "center",
                },
              ],
              [{ text: "", border: [false, false, false, false] }],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },

        {
          margin: [328, 0, 0, 0],

          table: {
            widths: [27, 100],
            headerRows: 1,
            body: [
              [
                {
                  text: "ตำแหน่ง",
                  margin: [0, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: `${!one_position ? "" : one_position}`,
                  margin: [0, 0, 0, 0],
                  border: [false, false, false, true],
                  alignment: "center",
                },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },
        {
          margin: [320, 0, 0, 0],
          table: {
            widths: [15, 15, 20, 50, 20, 25],
            headerRows: 1,
            body: [
              [
                {
                  text: `วันที่`,
                  border: [false, false, false, false],
                },
                {
                  text: `${r.sucess_time ? TH_dateSucess_day : ""}`,
                  border: [false, false, false, true],
                },
                {
                  text: `เดือน`,
                  border: [false, false, false, false],
                },
                {
                  text: `${r.sucess_time ? TH_dateSucess_month : ""}`,
                  border: [false, false, false, true],
                },
                {
                  text: `พ.ศ.`,
                  border: [false, false, false, false],
                },
                {
                  text: `${r.sucess_time ? Sucess_year : ""}`,
                  border: [false, false, false, true],
                },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },

        {
          margin: [328, 10, 0, 0],

          table: {
            widths: [30, 20, 40, 20, 45],
            headerRows: 1,
            body: [
              [
                {
                  text: "คำสั่ง",
                  border: [false, false, false, false],
                  margin: [0, -3, 0, 0],
                  style: "bigger",
                },
                {
                  image: `${r.status === "อนุมัติ" ? "checKed" : "unchecKed"}`,
                  border: [false, false, false, false],
                  width: 10,
                },
                {
                  text: "อนุญาต",
                  margin: [0, -3, 0, 0],
                  border: [false, false, false, false],
                  style: "bigger",
                },
                {
                  image: `${
                    r.status === "ไม่อนุมัติ" ? "checKed" : "unchecKed"
                  }`,
                  border: [false, false, false, false],
                  width: 10,
                },
                {
                  text: "ไม่อนุญาต",
                  margin: [0, -3, 0, 0],
                  border: [false, false, false, false],
                  style: "bigger",
                },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },
        {
          margin: [328, 0, 0, 0],

          table: {
            widths: [25, 100],
            headerRows: 1,
            body: [
              [
                {
                  text: "(ลงชื่อ)",
                  margin: [0, 25, 0, 0],
                  border: [false, false, false, false],
                },
                two_signature
                  ? {
                      image: `${two_signature}`,
                      width: 100,
                      height: 30,
                      margin: [0, 0, 0, 0],
                      border: [false, false, false, true],
                      alignment: "center",
                    }
                  : { text: "", border: [false, false, false, false] },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },

        {
          margin: [335, 0, 0, 0],

          table: {
            widths: [150],
            headerRows: 1,
            body: [
              [
                {
                  text: `( ${!two_name ? "" : two_name} )`,
                  margin: [0, 0, 0, 0],
                  border: [false, false, false, false],
                  alignment: "center",
                },
              ],
              [{ text: "", border: [false, false, false, false] }],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },

        {
          margin: [328, 0, 0, 0],

          table: {
            widths: [30, 100],
            headerRows: 1,
            body: [
              [
                {
                  text: "ตำแหน่ง",
                  margin: [0, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: `${!two_position ? "" : two_position}`,
                  margin: [0, 0, 0, 0],
                  border: [false, false, false, true],
                  alignment: "center",
                },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },
        {
          margin: [320, 0, 0, 0],
          table: {
            widths: [15, 15, 20, 50, 20, 25],
            headerRows: 1,
            body: [
              [
                {
                  text: `วันที่`,
                  border: [false, false, false, false],
                },
                {
                  text: `${r.sucess_time ? TH_dateSucess_day : ""}`,
                  border: [false, false, false, true],
                },
                {
                  text: `เดือน`,
                  border: [false, false, false, false],
                },
                {
                  text: `${r.sucess_time ? TH_dateSucess_month : ""}`,
                  border: [false, false, false, true],
                },
                {
                  text: `พ.ศ.`,
                  border: [false, false, false, false],
                },
                {
                  text: `${r.sucess_time ? Sucess_year : ""}`,
                  border: [false, false, false, true],
                },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },

        {
          text: "สถิติการลาในปีงบประมาณนี้",
          margin: [20, -200, 0, 0],
          alignment: "left",
          style: "bigger",
        },
        {
          margin: [20, 0, 0, 0],
          columns: [
            {
              style: "tableExample",
              alignment: "center",
              table: {
                body: [
                  [
                    "ลามาเเล้ว\n(วันทำการ)",
                    "ลาครั้งนี้\n(วันทำการ)",
                    "รวม\n(วันทำการ)",
                  ],
                  [
                    cntLeave?.[0]?.total || "-",
                    r.scheduled || "-",
                    Number(cntLeave?.[0]?.total) + Number(r.scheduled) || "-",
                  ],
                ],
              },
            },
          ],
        },
        {
          margin: [0, 0, 0, 0],

          table: {
            widths: [25, 100, 40],
            headerRows: 1,
            body: [
              [
                {
                  text: "(ลงชื่อ)",
                  margin: [0, 25, 0, 0],
                  border: [false, false, false, false],
                },
                one_signature
                  ? {
                      image: `${one_signature}`,
                      width: 100,
                      height: 30,
                      margin: [0, 0, 0, 0],
                      border: [false, false, false, true],
                      alignment: "center",
                    }
                  : { text: "", border: [false, false, false, false] },

                {
                  text: "ผู้ตรวจสอบ",
                  margin: [0, 25, 0, 0],
                  border: [false, false, false, false],
                },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },

        {
          margin: [10, 0, 0, 0],

          table: {
            widths: [150],
            headerRows: 1,
            body: [
              [
                {
                  text: `(........${!one_name ? "" : one_name}.......)`,
                  margin: [0, 0, 0, 0],
                  border: [false, false, false, false],
                  alignment: "center",
                },
              ],
              [{ text: "", border: [false, false, false, false] }],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },
        {
          margin: [0, 0, 0, 0],

          table: {
            widths: [27, 100],
            headerRows: 1,
            body: [
              [
                {
                  text: "ตำแหน่ง",
                  margin: [0, 0, 0, 0],
                  border: [false, false, false, false],
                },
                {
                  text: `${!one_position ? "" : one_position}`,
                  margin: [0, 0, 0, 0],
                  border: [false, false, false, true],
                  alignment: "center",
                },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },
        {
          margin: [10, 0, 0, 0],
          table: {
            widths: [15, 10, 40, 20],
            headerRows: 1,
            body: [
              [
                {
                  text: `วันที่`,
                  border: [false, false, false, false],
                },
                {
                  text: `${r.sucess_time ? TH_dateSucess_day : ""}`,
                  border: [false, false, false, true],
                },
                {
                  text: `${r.sucess_time ? TH_dateSucess_month : ""}`,
                  border: [false, false, false, true],
                },
                {
                  text: `${r.sucess_time ? Sucess_year : ""}`,
                  border: [false, false, false, true],
                },
              ],
              [
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
                { text: "", border: [false, false, false, false] },
              ],
            ],
          },
          layout: {
            hLineStyle: function (i, node) {
              if (i === 0 || i === node.table.body.length) {
                return null;
              }
              return { dash: { length: 1, space: 1 } };
            },
            vLineStyle: function (i, node) {
              if (i === 0 || i === node.table.widths.length) {
                return null;
              }
              return { dash: { length: 10 } };
            },
          },
        },
      ],
      styles: {
        header: {
          fontSize: 18,
          bold: true,
        },
        tableExample: {
          margin: [0, 5, 0, 15],
        },
        bigger: {
          fontSize: 15,
          bold: true,
        },
      },
      defaultStyle: {
        columnGap: 20,
        font: "THSarabunNew",
      },
      images: {
        checKedCicle: pickImage.checKedCicle,
        three: pickImage.three,
        two: pickImage.two,
        one: pickImage.one,
        checKed: pickImage.checKed,
        unchecKed: pickImage.unchecKed,
        cicle: pickImage.cicle,
        Krut: pickImage.Krut,
      },
    };
    pdfMake.createPdf(dd).open();
  }
};

export { FormLeave };
